import { useLayoutEffect } from "react";

/**
 * The browser tab title for one site page ("Premium Shop · Shelf Garden"), restored to whatever it was when the
 * page goes away — so the landing page keeps index.html's title. A layout effect, so a page already loaded sets
 * its title before the router's `page_view` (a passive effect) reads `document.title`.
 */
export function usePageTitle(title: string): void {
  useLayoutEffect(() => {
    const was = document.title;
    document.title = title;
    return () => { document.title = was; };
  }, [title]);
}
